// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrServiceForOptionDto
 */
export interface IOcrServiceForOptionDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrServiceForOptionDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IOcrServiceForOptionDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOcrServiceForOptionDto
     */
    full_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrServiceForOptionDto
     */
    relationship_type?: IOcrServiceForOptionDtoRelationshipTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IOcrServiceForOptionDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrServiceForOptionDto
     */
    is_suggested?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IOcrServiceForOptionDto
     */
    receipt_name?: string;
}

/**
* @export
* @enum {string}
*/
export enum IOcrServiceForOptionDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}


/**
 * Check if a given object implements the IOcrServiceForOptionDto interface.
 */
export function instanceOfIOcrServiceForOptionDto(value: object): value is IOcrServiceForOptionDto {
    return true;
}

export function IOcrServiceForOptionDtoFromJSON(json: any): IOcrServiceForOptionDto {
    return IOcrServiceForOptionDtoFromJSONTyped(json, false);
}

export function IOcrServiceForOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrServiceForOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'full_name': json['full_name'] == null ? undefined : json['full_name'],
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'is_suggested': json['is_suggested'] == null ? undefined : json['is_suggested'],
        'receipt_name': json['receipt_name'] == null ? undefined : json['receipt_name'],
    };
}

export function IOcrServiceForOptionDtoToJSON(json: any): IOcrServiceForOptionDto {
    return IOcrServiceForOptionDtoToJSONTyped(json, false);
}

export function IOcrServiceForOptionDtoToJSONTyped(value?: IOcrServiceForOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'dependent_id': value['dependent_id'],
        'full_name': value['full_name'],
        'relationship_type': value['relationship_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'is_suggested': value['is_suggested'],
        'receipt_name': value['receipt_name'],
    };
}

